import Vue from "vue";
import moment from "moment";
import VueScrollTo from "vue-scrollto";

import vuetify from "./plugins/vuetify";

import { Icon } from "leaflet";
import i18n from "@/plugins/i18n";
import App from "./App.vue";
import router from "@/router";
import "@/router.auth";
import store from "./store/store";
import initSW from "./registerServiceWorker";
import "@/assets/scss/main.scss";
import imageCache from "@/services/image-cache";
import { initMsal, handleRedirect, rememberFailedLogin } from "@/services/msal";
import { loginError } from "@/utilities/login-error";

import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
// comment for rebuild
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

moment.locale("nl");
Vue.config.productionTip = false;

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

initSW();
imageCache.init("mechanics");

async function start() {
  await fetch("/settings.json")
    .then(res => res.json())
    .then(data =>
      store.commit("inject-axios-variables", {
        baseUrl: data["VUE_APP_API"],
        trackJsApiKey: data["VUE_APP_TRACK_JS_API_KEY"],
        strichApiKey: data["VUE_APP_STRICH_API_KEY"],
        entraClientId: data["VUE_APP_ENTRA_CLIENT_ID"],
        entraTenantId: data["VUE_APP_ENTRA_TENANT_ID"]
      })
    );

  // Process the return from an Azure AD redirect login before the auth gate
  // below evaluates, so the exchanged token is already in the store.
  if (store.getters["entraClientId"]) {
    initMsal(store.getters["entraClientId"], store.getters["entraTenantId"]);

    await handleRedirect()
      .then(async result => {
        if (result && result.accessToken) {
          await store.dispatch("account/azureSignIn", { azureToken: result.accessToken });

          // MSAL clearing the #code hash fires a popstate, which makes the router
          // run its initial navigation while the token exchange is still in flight
          // and park the route on /inloggen. Re-navigate now that we are signed in.
          await router.replace("/").catch(() => {});
        }
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error("azure login failed", e);
        rememberFailedLogin(loginError(e));
      });
  }

  await store
    .dispatch("created")
    .catch(() => {})
    .then(() => {
      if (!store.getters["account/isAuthenticated"]) {
        store.dispatch("account/signOut");
      }
    });

  new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
}

start();
